
import { toString, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { PencilSimple, Check, Envelope, WhatsappLogo, ChatCircleText, QrCode, LinkSimple, ShareNetwork, TiktokLogo, YoutubeLogo, SnapchatLogo, InstagramLogo, Butterfly, FacebookLogo, LinkedinLogo, XLogo, GithubLogo, FileX, WifiSlash, MagnifyingGlass, CircleNotch, Heartbeat, Rocket, ListBullets, TrendUp, FunnelSimple, ClockCounterClockwise, Compass, SlidersHorizontal, CreditCard, Users, CurrencyDollar, Clock, CaretUp, CaretDown, ArrowSquareOut, ArrowRight, ArrowLeft, X, Info, Warning, Lock, CheckCircle, Circle, EyeSlash, Eye, SignOut, User, UserCircle, UserPlus, SignIn, Monitor, Moon, Sun, List, Image, Plus, Target, Heart, Sparkle, Barbell, Leaf, BookOpen, Waves, Bicycle, PersonSimpleRun, Footprints, XCircle, Trophy, HourglassMedium, Flame, HandHeart, MegaphoneSimple, CalendarBlank } from "@phosphor-icons/react";
import { createElement, useEffect, useState } from "react";
import React from "react";
import { ofArray, empty, singleton } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";

/**
 * Icon size tokens matching Tailwind width/height classes
 */
export class IconSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sm", "Md", "Lg"];
    }
}

export function IconSize_$reflection() {
    return union_type("Shared.Icons.IconSize", [], IconSize, () => [[], [], []]);
}

/**
 * Icon weight variants (Phosphor supports 6, we use 2)
 */
export class IconWeight extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Regular", "Fill"];
    }
}

export function IconWeight_$reflection() {
    return union_type("Shared.Icons.IconWeight", [], IconWeight, () => [[], []]);
}

/**
 * Named icons used throughout the app, mapped to Phosphor icon component names.
 * Each case name matches the Phosphor React export name exactly.
 */
export class IconName extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PencilSimple", "CalendarBlank", "MegaphoneSimple", "HandHeart", "Flame", "HourglassMedium", "Trophy", "XCircle", "Footprints", "PersonSimpleRun", "Bicycle", "Waves", "BookOpen", "Leaf", "Barbell", "Sparkle", "Heart", "Target", "Plus", "Image", "List", "Sun", "Moon", "Monitor", "SignIn", "UserPlus", "UserCircle", "User", "SignOut", "Eye", "EyeSlash", "Circle", "CheckCircle", "Lock", "Warning", "Info", "X", "ArrowLeft", "ArrowRight", "CaretDown", "CaretUp", "Clock", "CurrencyDollar", "Users", "CreditCard", "SlidersHorizontal", "Compass", "ClockCounterClockwise", "ArrowSquareOut", "FunnelSimple", "TrendUp", "ListBullets", "Rocket", "Heartbeat", "CircleNotch", "MagnifyingGlass", "WifiSlash", "FileX", "GithubLogo", "XLogo", "LinkedinLogo", "FacebookLogo", "Butterfly", "InstagramLogo", "SnapchatLogo", "YoutubeLogo", "TiktokLogo", "ShareNetwork", "LinkSimple", "QrCode", "ChatCircleText", "WhatsappLogo", "Envelope", "Check"];
    }
}

export function IconName_$reflection() {
    return union_type("Shared.Icons.IconName", [], IconName, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

/**
 * Returns the Tailwind width/height classes for an icon size
 */
export function sizeClass(size) {
    switch (size.tag) {
        case 1:
            return "w-5 h-5";
        case 2:
            return "w-6 h-6";
        default:
            return "w-4 h-4";
    }
}

/**
 * Returns the Phosphor weight string for the JS component prop
 */
export function weightString(weight) {
    if (weight.tag === 1) {
        return "fill";
    }
    else {
        return "regular";
    }
}

function resolveComponent(name) {
    switch (name.tag) {
        case 1:
            return CalendarBlank;
        case 2:
            return MegaphoneSimple;
        case 3:
            return HandHeart;
        case 4:
            return Flame;
        case 5:
            return HourglassMedium;
        case 6:
            return Trophy;
        case 7:
            return XCircle;
        case 8:
            return Footprints;
        case 9:
            return PersonSimpleRun;
        case 10:
            return Bicycle;
        case 11:
            return Waves;
        case 12:
            return BookOpen;
        case 13:
            return Leaf;
        case 14:
            return Barbell;
        case 15:
            return Sparkle;
        case 16:
            return Heart;
        case 17:
            return Target;
        case 18:
            return Plus;
        case 19:
            return Image;
        case 20:
            return List;
        case 21:
            return Sun;
        case 22:
            return Moon;
        case 23:
            return Monitor;
        case 24:
            return SignIn;
        case 25:
            return UserPlus;
        case 26:
            return UserCircle;
        case 27:
            return User;
        case 28:
            return SignOut;
        case 29:
            return Eye;
        case 30:
            return EyeSlash;
        case 31:
            return Circle;
        case 32:
            return CheckCircle;
        case 33:
            return Lock;
        case 34:
            return Warning;
        case 35:
            return Info;
        case 36:
            return X;
        case 37:
            return ArrowLeft;
        case 38:
            return ArrowRight;
        case 48:
            return ArrowSquareOut;
        case 39:
            return CaretDown;
        case 40:
            return CaretUp;
        case 41:
            return Clock;
        case 42:
            return CurrencyDollar;
        case 43:
            return Users;
        case 44:
            return CreditCard;
        case 45:
            return SlidersHorizontal;
        case 46:
            return Compass;
        case 47:
            return ClockCounterClockwise;
        case 49:
            return FunnelSimple;
        case 50:
            return TrendUp;
        case 51:
            return ListBullets;
        case 52:
            return Rocket;
        case 53:
            return Heartbeat;
        case 54:
            return CircleNotch;
        case 55:
            return MagnifyingGlass;
        case 56:
            return WifiSlash;
        case 57:
            return FileX;
        case 58:
            return GithubLogo;
        case 59:
            return XLogo;
        case 60:
            return LinkedinLogo;
        case 61:
            return FacebookLogo;
        case 62:
            return Butterfly;
        case 63:
            return InstagramLogo;
        case 64:
            return SnapchatLogo;
        case 65:
            return YoutubeLogo;
        case 66:
            return TiktokLogo;
        case 67:
            return ShareNetwork;
        case 68:
            return LinkSimple;
        case 69:
            return QrCode;
        case 70:
            return ChatCircleText;
        case 71:
            return WhatsappLogo;
        case 72:
            return Envelope;
        case 73:
            return Check;
        default:
            return PencilSimple;
    }
}

/**
 * Render a Phosphor icon as a React element.
 * 
 * The icon SVG is rendered only after the component has mounted on the client.
 * On the first (hydration) render the span is emitted empty, exactly matching the
 * server-side placeholder span (see the #else branch). This keeps the hydration
 * markup identical between server and client.
 * 
 * suppressHydrationWarning only silences attribute/text differences on a single
 * node — it does NOT suppress a missing child element. React's concurrent
 * hydrateRoot throws "Expected server HTML to contain a matching <svg> in <span>"
 * (React #418/#423) when the server span is empty but the client span already
 * contains the SVG. Deferring the SVG to a post-mount effect removes that mismatch.
 */
export function icon($props) {
    const weight = $props.weight;
    const size = $props.size;
    const name = $props.name;
    const patternInput = useState(false);
    useEffect(() => {
        patternInput[1](true);
    }, []);
    const children = patternInput[0] ? singleton(createElement(resolveComponent(name), {
        className: sizeClass(size),
        weight: weightString(weight),
    })) : empty();
    return HtmlHelper_createElement("span", ofArray([["className", sizeClass(size)], ["suppressHydrationWarning", true], ["aria-hidden", "true"], ["data-icon", toString(name)], ["children", children]]));
}

//# sourceMappingURL=Icons.js.map
